document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('a[href$="#cookie-settings-custom"]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      event.preventDefault(); 
      if (typeof privacyBanner !== 'undefined' && typeof privacyBanner.showPreferences === 'function') {
        privacyBanner.showPreferences(); 
      } else {
        console.warn('privacyBanner.showPreferences ist nicht definiert.');
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', function() {
  // Event-Listener für alle Links mit Ankern hinzufügen
  document.querySelectorAll('a[href*="#"]:not([href="#"])').forEach(function(link) {
    link.addEventListener('click', function(event) {
      // Überprüfen, ob der Link zur gleichen Seite gehört
      const samePath = location.pathname.replace(/^\//, '') === link.pathname.replace(/^\//, '');
      const sameHost = location.hostname === link.hostname;

      if (samePath || sameHost) {
        // Ziel-Element basierend auf dem Hash des Links finden
        let target = document.querySelector(link.hash);
        const headerHeight = document.querySelector('.cc-header')?.offsetHeight + 30 || 80;

        if (!target) {
          target = document.querySelector(`[name="${link.hash.slice(1)}"]`);
        }

        if (target) {
          event.preventDefault();
          // Weicher Bildlauf zum Ziel-Element
          window.scrollTo({
            top: target.getBoundingClientRect().top + window.pageYOffset - headerHeight,
            behavior: 'smooth'
          });
        }
      }
    });
  });
});